/* Motus Nutrition theme. Small, dependency free. */
(function () {
  function prefersReduced() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  // The cart icon the item should fly to. The header one on desktop, the bottom
  // bar on phones. Whichever is actually laid out wins, so this follows the
  // breakpoint without knowing what the breakpoint is.
  function cartTarget() {
    var els = document.querySelectorAll('.cart-link, .bottombar a[href*="cart"]');
    for (var i = 0; i < els.length; i++) {
      var r = els[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0) return els[i];
    }
    return null;
  }

  function sourceImageFor(form) {
    var scope = form.closest && form.closest('article, .card, .stack, .cstack, .pdp');
    var img = scope && scope.querySelector('img');
    return img || document.querySelector('.pdp .gallery .main img') || document.querySelector('.gallery img');
  }

  // Mostly on screen? A card's image can sit above the fold while its button is
  // in view, and a clone launched from off screen reads as a glitch flying in
  // from nowhere. In that case the button is the honest origin.
  function mostlyVisible(r) {
    if (!r || !r.width || !r.height) return false;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var vw = window.innerWidth || document.documentElement.clientWidth;
    var visY = Math.max(0, Math.min(r.bottom, vh) - Math.max(r.top, 0));
    var visX = Math.max(0, Math.min(r.right, vw) - Math.max(r.left, 0));
    return (visY / r.height) > 0.5 && (visX / r.width) > 0.5;
  }

  // Fly a COPY of the product image to the cart. Never the image itself: moving
  // the real node would reflow the card it came out of. Fixed + pointer-events
  // none keeps the clone out of layout and out of the way of a second click.
  function flyToCart(form, originBtn) {
    if (prefersReduced()) return;
    if (!document.body.animate) return;              // no WAAPI, skip silently
    var img = sourceImageFor(form), target = cartTarget();
    if (!img || !target) return;
    var s = img.getBoundingClientRect(), t = target.getBoundingClientRect();
    if (!t.width) return;

    // Launch from the image when the shopper can actually see it, otherwise
    // from the control they just pressed.
    var useImage = mostlyVisible(s);
    if (!useImage) {
      var br = originBtn && originBtn.getBoundingClientRect();
      if (!br || !br.width) return;
      s = br;
    }
    if (!s.width || !s.height) return;

    var size = Math.min(s.width, 170);
    var clone = document.createElement('img');
    clone.src = img.currentSrc || img.src;
    clone.alt = '';
    clone.className = 'fly-clone';
    clone.style.width = size + 'px';
    clone.style.height = (useImage ? (size * (s.height / s.width)) : size) + 'px';
    clone.style.left = (s.left + (s.width - size) / 2) + 'px';
    clone.style.top = (s.top + (useImage ? 0 : (s.height - size) / 2)) + 'px';
    document.body.appendChild(clone);

    var c = clone.getBoundingClientRect();
    var dx = (t.left + t.width / 2) - (c.left + c.width / 2);
    var dy = (t.top + t.height / 2) - (c.top + c.height / 2);

    // Four beats, not a straight slide. It picks up first (a brief scale past
    // 1 so the eye catches the thing leaving), arcs high, and stays close to
    // full opacity almost the whole way. Fading early is what made the first
    // version easy to miss: by mid flight there was barely anything to see.
    var anim = clone.animate([
      { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1, offset: 0 },
      { transform: 'translate(' + (dx * 0.06) + 'px,' + (dy * 0.04 - 26) + 'px) scale(1.18) rotate(-3deg)', opacity: 1, offset: .16 },
      { transform: 'translate(' + (dx * 0.55) + 'px,' + (dy * 0.45 - 150) + 'px) scale(.78) rotate(-9deg)', opacity: 1, offset: .62 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.22) rotate(-16deg)', opacity: .45, offset: 1 }
    ], { duration: 900, easing: 'cubic-bezier(.34,.05,.2,1)', fill: 'forwards' });

    function land() {
      if (clone.parentNode) clone.parentNode.removeChild(clone);
      target.classList.add('catch');
      setTimeout(function () { target.classList.remove('catch'); }, 620);
    }
    anim.onfinish = land;
    // A clone must never be left stuck on the page if onfinish does not fire.
    setTimeout(function () { if (clone.parentNode) land(); }, 1800);
  }

  // Quantity steppers (product page and cart)
  document.querySelectorAll('.qty').forEach(function (box) {
    var input = box.querySelector('input[type="number"]');
    if (!input) return;
    box.querySelectorAll('[data-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-qty'), 10) || 0;
        var min = parseInt(input.getAttribute('min') || '0', 10);
        var next = (parseInt(input.value, 10) || 0) + step;
        if (next < min) next = min;
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // Product gallery thumbnails swap the main image
  var main = document.querySelector('.gallery .main img');
  if (main) {
    document.querySelectorAll('.thumbs button[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        main.src = btn.getAttribute('data-thumb');
        main.removeAttribute('srcset');
        document.querySelectorAll('.thumbs button').forEach(function (b) { b.classList.remove('on'); });
        btn.classList.add('on');
      });
    });
  }

  // Collection sort select navigates with sort_by
  var sort = document.querySelector('select[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  // Add to cart without leaving the page: the product form and every stack form
  // (the stack form posts items[n][id] for each component, so three lines land in the cart).
  // Keeps the header and bottom-bar cart counts honest after the add.
  if (window.fetch && window.FormData) {
    // card-form is the Add to cart on every product card, which is the most
    // common one on the site. It was never bound, so those adds full-page
    // reloaded with no count change, no label change and no motion at all.
    document.querySelectorAll('form[id^="product-form-"], form.stack-form, form.card-form').forEach(function (buyForm) {
      buyForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var btns = Array.prototype.slice.call(buyForm.querySelectorAll('button[type="submit"]'));
        if (buyForm.id) btns = btns.concat(Array.prototype.slice.call(document.querySelectorAll('button[form="' + buyForm.id + '"]')));
        btns.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
        // Fly on submit, not on response: the feedback has to land with the
        // click or it reads as lag. A failed add falls through to a reload,
        // which clears the clone anyway.
        flyToCart(buyForm, btns[0]);
        fetch('/cart/add.js', { method: 'POST', body: new FormData(buyForm), headers: { 'Accept': 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch('/cart.js'); })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('.cart-count, .bottombar .count').forEach(function (el) {
              el.textContent = cart.item_count;
              el.classList.remove('pop');
              void el.offsetWidth;          // restart the animation if you add twice quickly
              el.classList.add('pop');
            });
            document.querySelectorAll('.cart-link').forEach(function (el) {
              el.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' items');
              el.classList.remove('ring');
              void el.offsetWidth;
              el.classList.add('ring');
              setTimeout(function () { el.classList.remove('ring'); }, 560);
            });
            btns.forEach(function (b) {
              b.disabled = false; b.removeAttribute('aria-busy');
              b.classList.add('is-added');
              var s = b.querySelector('span');
              var t = s ? s.textContent : null;
              if (s) s.textContent = 'Added';
              setTimeout(function () { b.classList.remove('is-added'); if (s) s.textContent = t; }, 1600);
            });
          })
          .catch(function () { btns.forEach(function (b) { b.disabled = false; b.removeAttribute('aria-busy'); }); buyForm.submit(); });
      });
    });
  }

  // Scroll reveal. Section-level only, fires once, transform and opacity only so
  // nothing reflows. The html.js-motion class is what switches the CSS on, so a
  // visitor with JS off or a failed script still sees every section.
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if ('IntersectionObserver' in window && !reduced) {
    document.documentElement.classList.add('js-motion');
    var targets = document.querySelectorAll('.sec-head, .tiles, .cycle .phases, .stacks .stack, .discs, .guide, .story, .landing-faq .grid, .final, .pdp .gallery, .pdp .buy, .panel');
    Array.prototype.forEach.call(targets, function (el) {
      el.classList.add('reveal');
      if (el.children.length > 1 && el.children.length <= 8) el.setAttribute('data-stagger', '');
    });
    // Once the entrance has played, stand down. While data-stagger is set, its
    // transition rule overrides each child's own, so a tile's hover shadow had
    // no transition at all and its lift ran at the reveal's 320ms rather than
    // the 250ms hover. Both the observer and the failsafe below have to call
    // this: the failsafe used to reveal elements and leave them stomped.
    function standDown(el) {
      if (!el.hasAttribute('data-stagger')) return;
      var settle = (el.children.length * 60) + 500;
      setTimeout(function () {
        el.removeAttribute('data-stagger');
        Array.prototype.forEach.call(el.children, function (child) { child.style.transitionDelay = ''; });
      }, settle);
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        if (el.hasAttribute('data-stagger')) {
          Array.prototype.forEach.call(el.children, function (child, i) {
            child.style.transitionDelay = (i * 60) + 'ms';
          });
        }
        el.classList.add('in');
        standDown(el);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    Array.prototype.forEach.call(targets, function (el) { io.observe(el); });

    // Failsafe. Copy must never be left invisible because an observer missed a
    // fast scroll, an anchor jump, or a restored scroll position. Anything still
    // hidden after 2.5s is shown regardless.
    setTimeout(function () {
      Array.prototype.forEach.call(targets, function (el) {
        if (!el.classList.contains('in')) { el.classList.add('in'); standDown(el); io.unobserve(el); }
      });
    }, 2500);
  }

  // Header: desktop sub-menus open on hover and focus (CSS); the toggle buttons serve keyboard and touch.
  document.querySelectorAll('.has-sub .sub-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var li = btn.parentNode, open = li.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
  // Remove a cart line without a reload. The row leaves, then the rows below it
  // ride up into the gap. Both halves are transform and opacity only: the row is
  // pulled from the DOM in one go and the survivors are FLIPped from where they
  // were to where they now are, so nothing animates a layout property.
  if (window.fetch) {
    document.querySelectorAll('.cart-table a.remove').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var row = link.closest('tr');
        var key = row && row.getAttribute('data-key');
        if (!row || !key) return;                 // no key, let the href do its job
        e.preventDefault();
        if (row.hasAttribute('data-removing')) return;
        row.setAttribute('data-removing', '');
        link.setAttribute('aria-busy', 'true');

        var body = row.parentNode;
        var siblings = Array.prototype.slice.call(body.children);
        var firstTops = siblings.map(function (r) { return r.getBoundingClientRect().top; });
        var reduced = prefersReduced();

        function collapse() {
          // Read every survivor's position BEFORE the row leaves, then play the
          // difference as a transform after it has gone.
          row.parentNode.removeChild(row);
          if (reduced || !document.body.animate) return;
          siblings.forEach(function (r, i) {
            if (r === row || !r.parentNode) return;
            var dy = firstTops[i] - r.getBoundingClientRect().top;
            if (!dy) return;
            r.animate([{ transform: 'translateY(' + dy + 'px)' }, { transform: 'none' }],
              { duration: 320, easing: 'cubic-bezier(.2,.7,.2,1)' });
          });
        }

        function exit(done) {
          if (reduced || !row.animate) { done(); return; }
          var a = row.animate([
            { transform: 'none', opacity: 1 },
            { transform: 'translateX(26px)', opacity: .5, offset: .45 },
            { transform: 'translateX(90px)', opacity: 0 }
          ], { duration: 340, easing: 'cubic-bezier(.5,0,.75,0)', fill: 'forwards' });
          a.onfinish = done;
          setTimeout(function () { if (row.parentNode) done(); }, 700);
        }

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        })
          .then(function (r) { if (!r.ok) throw new Error('remove failed'); return r.json(); })
          .then(function (cart) {
            // The line is already gone by now. Following link.href would ask
            // Shopify to remove it a second time, which is what produced
            // "no valid id or line parameter" on the last item in the cart.
            if (cart.item_count === 0) { window.location.assign('/cart'); return; }
            var ran = false;
            exit(function () {
              if (ran) return; ran = true;
              collapse();
              document.querySelectorAll('.cart-count, .bottombar .count').forEach(function (el) {
                el.textContent = cart.item_count;
                el.classList.remove('dip'); void el.offsetWidth; el.classList.add('dip');
              });
              document.querySelectorAll('.cart-link').forEach(function (el) {
                el.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' items');
              });
              var sub = document.querySelector('.subtotal strong');
              if (sub && window.Shopify && Shopify.formatMoney) sub.textContent = Shopify.formatMoney(cart.total_price);
              else if (sub) sub.textContent = '$' + (cart.total_price / 100).toFixed(2);
            });
          })
          .catch(function () {
            row.removeAttribute('data-removing');
            link.removeAttribute('aria-busy');
            window.location.href = link.href;   // fall back to the plain link
          });
      });
    });
  }

  // Policy pages: build a contents rail from the headings that are actually in
  // the document. Shopify owns this markup and the copy changes in the admin, so
  // a hand-written list would drift; this one cannot. It also gives every section
  // a stable id, which is what makes /policies/privacy-policy#sms style deep
  // links possible at all. An A2P reviewer is hunting for one block.
  (function () {
    var container = document.querySelector('.shopify-policy__container');
    if (!container) return;
    var body = container.querySelector('.shopify-policy__body');
    if (!body) return;
    var heads = Array.prototype.slice.call(body.querySelectorAll('h2'));
    if (heads.length < 3) return;                 // too short to need a rail

    var slug = function (t) {
      return t.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 48);
    };
    var used = {};
    var nav = document.createElement('nav');
    nav.className = 'policy-toc';
    nav.setAttribute('aria-label', 'On this page');
    var list = document.createElement('ol');
    nav.appendChild(Object.assign(document.createElement('h2'), { textContent: 'On this page' }));
    nav.appendChild(list);

    heads.forEach(function (h) {
      var base = slug(h.textContent || 'section') || 'section';
      var id = base;
      var n = 2;
      while (used[id] || (document.getElementById(id) && document.getElementById(id) !== h)) { id = base + '-' + n++; }
      used[id] = true;
      if (!h.id) h.id = id;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.appendChild(a);
      list.appendChild(li);
    });

    container.insertBefore(nav, body);
    container.classList.add('has-toc');

    // Mark the section you are in. Reveal-style observer, no scroll handler.
    if ('IntersectionObserver' in window) {
      var links = {};
      Array.prototype.forEach.call(list.querySelectorAll('a'), function (a) {
        links[a.getAttribute('href').slice(1)] = a;
      });
      var spy = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var a = links[e.target.id];
          if (!a) return;
          if (e.isIntersecting) {
            Array.prototype.forEach.call(list.querySelectorAll('a.on'), function (x) { x.classList.remove('on'); });
            a.classList.add('on');
          }
        });
      }, { rootMargin: '-130px 0px -70% 0px' });
      heads.forEach(function (h) { spy.observe(h); });
    }
  })();

  // Header condenses once you are past the hero. Class toggle only, and the
  // read is rAF-throttled so the scroll handler never measures per event.
  var header = document.querySelector('header.site');
  if (header) {
    // No rAF latch here. Reading pageYOffset forces no layout, so the throttle
    // bought nothing and cost correctness: one dropped frame left the "ticking"
    // flag stuck true and the header froze in whichever state it was in.
    var wasScrolled = null;
    var onScroll = function () {
      var now = window.pageYOffset > 60;
      if (now === wasScrolled) return;
      wasScrolled = now;
      header.classList.toggle('scrolled', now);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // FAQ accordions. Opening needs no JS: the row grows when the browser sets
  // [open]. Closing does, because the browser hides the content the instant the
  // attribute goes, with nothing left to animate. So the close is intercepted,
  // played, and the attribute removed at the end.
  document.querySelectorAll('details').forEach(function (d) {
    var ans = d.querySelector('.ans');
    var summary = d.querySelector('summary');
    if (!ans || !summary) return;
    summary.addEventListener('click', function (e) {
      if (!d.open) return;                       // opening: let the browser do it
      if (prefersReduced()) return;
      e.preventDefault();
      if (d.hasAttribute('data-closing')) return;
      // An attribute, never an inline style. The first version pinned 1fr inline
      // and dropped to 0fr in a rAF; when that frame landed after the safety
      // timeout had already cleaned up, the stale inline 0fr outranked the
      // stylesheet and the next open expanded to nothing.
      d.setAttribute('data-closing', '');
      var finish = function () {
        ans.removeEventListener('transitionend', onEnd);
        d.removeAttribute('data-closing');
        d.open = false;
      };
      var onEnd = function (ev) { if (ev.propertyName === 'grid-template-rows') finish(); };
      ans.addEventListener('transitionend', onEnd);
      // transitionend can be missed on a background tab; never strand it open.
      setTimeout(function () { if (d.hasAttribute('data-closing')) finish(); }, 600);
    });
  });

  // A panel pinned open by tap or keyboard stays open when the pointer moves to
  // a sibling, and the two panels overlap. Opening one closes the rest.
  document.querySelectorAll('.menu .has-sub').forEach(function (li) {
    li.addEventListener('mouseenter', function () {
      document.querySelectorAll('.menu .has-sub.open').forEach(function (other) {
        if (other === li) return;
        other.classList.remove('open');
        var t = other.querySelector('.sub-toggle');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    });
  });

  // Close an open mega panel on Escape, and on a click outside it. Hover alone
  // cannot close a panel that was opened by tap or keyboard.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.menu .has-sub.open').forEach(function (li) {
      li.classList.remove('open');
      var t = li.querySelector('.sub-toggle');
      if (t) { t.setAttribute('aria-expanded', 'false'); t.focus(); }
    });
  });
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.menu .has-sub.open').forEach(function (li) {
      if (li.contains(e.target)) return;
      li.classList.remove('open');
      var t = li.querySelector('.sub-toggle');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  });

  // Mobile menu panel
  var mbtn = document.querySelector('.menu-btn'), panel = document.getElementById('mobile-menu');
  if (mbtn && panel) {
    mbtn.addEventListener('click', function () {
      var open = panel.hidden; panel.hidden = !open;
      mbtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('menu-open', open);
    });
  }
})();
